/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <section
    v-if="loaded"
    aria-labelledby="manageH1"
  >
    <h1
      id="manageH1"
      class="sr-only"
    >
      Manage Recordings
    </h1>
    <h2
      id="manage-nav"
      class="sr-only"
    >
      Manage Recordings Navigation
    </h2>
    <nav
      aria-labelledby="manage-nav"
    >
      <ul
        :class="(allTabsShown) ? 'nav nav-tabs manage-menu' : 'nav nav-tabs'"
        aria-label="page navigation"
      >
        <li
          v-if="showManageGroups"
          :class="{ active: tab === 'my classes' }"
        >
          <a
            id="myclasseslink"
            ref="myclasseslink"
            href="#"
            @click.prevent="loadTab('my classes')"
            @keypress="loadTab('my classes', $event)"
          >
            <span v-if="orgType == 'edu'">
              My Classes
            </span>
            <span v-if="orgType != 'edu'">
              My Groups
            </span>
          </a>
        </li>
        <li
          v-if="showMyRecordingsTab"
          :class="{ active: tab === 'my recordings' }"
        >
          <a
            id="myrecordingslink"
            ref="myrecordingslink"
            href="#"
            @click.prevent="loadTab('my recordings')"
            @keypress="loadTab('my recordings', $event)"
          >
            My Recordings
          </a>
        </li>
        <li
          v-if="showWordspotting"
          :class="{ active: tab === 'word spotting' }"
        >
          <a
            id="wordspottinglink"
            ref="wordspottinglink"
            href="#"
            @click.prevent="loadTab('word spotting')"
            @keypress="loadTab('word spotting', $event)"
          >
            Wordspotting
          </a>
        </li>
      </ul>
    </nav>
    <div
      v-show="tab === 'my classes'"
      v-if="showManageGroups"
      class="tab-well"
    >
      <h2
        id="myclassesheader"
        class="sr-only"
      >
        {{ isEdu ? 'My Classes' : 'My Groups' }}
      </h2>
      <keep-alive>
        <manage-groups
          :org-type="orgType"
          :groups="activeGroups"
          :is-group-manager="isGroupManager"
        />
      </keep-alive>
    </div>
    <div
      v-show="tab === 'my recordings'"
      class="tab-well"
    >
      <h2
        id="myrecordingsheader"
        class="sr-only"
      >
        Manage Recordings
      </h2>
      <manage-recordings />
    </div>
    <div
      v-if="showWordspotting"
      v-show="tab === 'word spotting'"
      class="tab-well"
    >
      <h2
        id="wordspottingheader"
        class="sr-only"
      >
        Manage Wordspotting
      </h2>
      <manage-wordspotting />
    </div>
  </section>
</template>


<style lang="less" scoped>
  .nav-tabs li {
    width: 150px;
  }
  .manage-menu li a {
    padding-left: 6px;
    padding-right: 6px;
  }
  #manageH1 {
    margin-top: 0 !important;
    padding-top: 0;
  }
</style>

<script>
import ManageWordspotting from '../layout/ManageWordspotting';
import ManageRecordings from '../layout/ManageRecordings';
import ManageGroups from '../layout/ManageGroups';
import BasePage from './BasePage';

export default {
  components: { ManageWordspotting, ManageRecordings, ManageGroups },
  mixins: [BasePage],
  data() {
    return {
      loaded: false,
      tab: null,
      showSharedGroupsTabToSpeakers: false,
      showMyRecordingsTab: true,
    };
  },
  computed: {
    allTabsShown() {
      return this.showManageGroups && this.showMyRecordingsTab && this.showWordspotting;
    },
    showManageGroups() {
      return this.isGroupManager || this.showSharedGroupsTabToSpeakers;
    },
    showWordspotting() {
      const org = this.$store.getters.org;
      const groups = (org && typeof org.settings !== 'undefined' && org.settings.Custom_Wordspotting_For_Groups);
      const orgs = (org && typeof org.settings !== 'undefined' && org.settings.Custom_Wordspotting_For_Orgs);
      const users = (org && typeof org.settings !== 'undefined' && org.settings.Custom_Wordspotting_For_Users);

      return ((groups && this.isGroupManager) || (orgs && this.isOrgLevelAdmin) || users);
    },
  },
  methods: {
    basePageCreated() {
      if (this.assignmentsEnabled) {
        const bouncePage = (this.isGroupManager) ? 'coach-dashboard' : 'speaker-dashboard';
        this.$router.push({ name: bouncePage });
      }

      this.loaded = true;
      // This specifies the default tab
      this.tab = (this.isGroupManager) ? 'my classes' : 'my recordings';

      // Support auto-selecting a tab via router.
      if (this.$route.query.tab && this.$route.query.tab !== this.tab) {
        this.tab = this.$route.query.tab;
        this.$route.query.tab = null;
      }

      // Now, set showSharedGroupsTabToSpeakers
      this.activeGroups.forEach((group) => {
        if (group.speakerPrivacyLevel > 0 && group.speakerPrivacyLevel < 4) {
          this.showSharedGroupsTabToSpeakers = true;
        }
      });

      if (this.isGroupManager && !this.speakerGroups.length) {
        // Users who aren't speaker in a group shouldn't see My Recordings
        this.showMyRecordingsTab = false;
        this.showGroups = true;
      }
    },
  }
};
</script>
